<template>
  <div
    class="card mb-25 border-0 rounded-0 bg-white text-center error-404-card"
  >
    <div class="card-body letter-spacing">
      <img src="../assets/images/error-404.png" alt="error-image" />
      <h1 class="fw-bold text-black">OOPS! 404 Página não encontrada!</h1>
      <p v-if="notFoundPath" class="text-muted mb-4">
        A página "<code>{{ notFoundPath }}</code>" não existe.
      </p>
      <div class="d-flex justify-content-center gap-3">
        <router-link
          class="default-btn transition text-decoration-none border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
          to="/"
        >
          Voltar ao inicio
        </router-link>
        <button
          @click="goBack"
          class="btn btn-outline-secondary pt-10 pb-10 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
        >
          Voltar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default {
  name: "ErrorPage",
  setup() {
    const route = useRoute()
    const router = useRouter()
    
    const notFoundPath = computed(() => {
      // O parametro catchAll contem o caminho nao encontrado
      return route.params.catchAll || route.fullPath
    })
    
    const goBack = () => {
      // Verifica se há histórico para voltar, senão vai para home
      if (window.history.length > 1) {
        router.back()
      } else {
        router.push('/')
      }
    }
    
    return {
      notFoundPath,
      goBack
    }
  }
};
</script>